import ObjectBuilderInterface from "@/modules/api/object-builder.interface";
import ApiCollectionResponseParserService from "@/modules/api/api-collection-response-parser.service";
import ApiService from "@/modules/api/api.service";
import BasicRepository from "@/modules/api/basic.repository";
import { Dictionary } from "@/lib/Dictionary.type";
import { ResourceCollection } from "@/modules/api/resource.collection";

import PenaltyRule from "./penalty-rule.model";

export default class PenaltyRuleRepository extends BasicRepository<PenaltyRule> {
  constructor(
    api: ApiService,
    objectBuilder: ObjectBuilderInterface<PenaltyRule>,
    responseParser: ApiCollectionResponseParserService<PenaltyRule>
  ) {
    super("penalty_rules", api, objectBuilder, responseParser);
  }

  public async getByFactoryId(
    factoryId: string
  ): Promise<ResourceCollection<PenaltyRule>> {
    return this.fetchList({ factoryId: factoryId }, 1, 999);
  }

  public async saveItemsForFactory(
    items: PenaltyRule[],
    factoryId: string
  ): Promise<PenaltyRule[]> {
    const itemsData = items.map((item) => this.prepareData(item));

    const response = await this.api.post("penalty_rules/update_requests", {
      factory: factoryId,
      items: itemsData,
    });

    const result = this.responseParser.parse(response.data, this.objectBuilder);

    return result.getItems();
  }

  protected prepareData(item: PenaltyRule): Dictionary<string | number> {
    const data: Dictionary<string | number> = {
      id: item.id,
      factory: item.factory,
      product: +item.product,
      delay: item.productionDaysDelay,
      percent: item.penaltyPercent,
    };

    return data;
  }
}
